module.exports = __webpack_public_path__ + "img/DF_logo.457ae711.svg";